import React from 'react'
import styled from 'styled-components'

import { useContactData } from '../hooks'
import FBLogoBlack from '../images/HMC_FBIcon_Black.png'

const ContactDetailsWrapper = styled.div`
  p {
    color: #999;
  }

  h4 {
    margin-bottom: ${props => props.theme.spacing.sm};

    @media (max-width: ${props => props.theme.breakpoints.sm}) {
      margin-bottom: 30px;
    }
  }

  a {
    text-decoration: none;
    color: ${props => props.theme.colors.primary};
  }

  h4 {
    a {
      display: flex;
      align-items: center;

      img {
        margin-left: 7px;
        width: 20px;
      }
    }
  }

  iframe {
    margin-top: 40px;
    width: 100%;
    height: 380px;
  }

  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    padding-top: ${props => props.theme.spacing.sm};
  }
`

export const ContactDetails = () => {
  const { contactData } = useContactData()
  return (
    <ContactDetailsWrapper>
      <p>Email</p>
      <h4>
        <a href={`mailto:${contactData.email}`}>{contactData.email}</a>
      </h4>
      <p>Phone</p>
      <h4>{contactData.phone}</h4>
      <h4>
        <a target="_blank" rel="noopener noreferrer" href={contactData.facebook}>
          {contactData.facebookText} <img src={FBLogoBlack} alt={contactData.facebookText} />
        </a>
      </h4>
      <div></div>
    </ContactDetailsWrapper>
  )
}
